// Infer an OS-family label from a device string. Returns null when nothing matches.
// Order matters: more-specific families first (iPad before iOS, Quest before Android).
const OS_RULES = [
  { label: 'visionOS', keywords: ['visionos', 'vision pro', 'apple vision'] },
  { label: 'Meta Horizon OS', keywords: ['quest', 'meta horizon', 'oculus'] },
  { label: 'iPadOS', keywords: ['ipad'] },
  { label: 'iOS', keywords: ['iphone', ' ios'] },
  { label: 'macOS', keywords: ['macbook', 'macintosh', 'macos', 'mac ', 'os x'] },
  { label: 'Android', keywords: ['android', 'pixel', 'galaxy', 'samsung'] },
  { label: 'Windows', keywords: ['windows', 'win32', 'win64'] }
]

export const inferOsLabel = device => {
  if (!device || typeof device !== 'string') return null
  const s = ` ${device.toLowerCase()} `
  for (const rule of OS_RULES) {
    if (rule.keywords.some(k => s.includes(k))) return rule.label
  }
  return null
}
